package com.devi3east.bashbuddy.purchase.responses

import com.devi3east.bashbuddy.purchase.domain.models.SubPurchaseInit
import kotlinx.serialization.Serializable

@Serializable
data class PurchaseInitResponse(
    val purchaseId: String,
    val subPurchases: List<SubPurchaseInit>
)